<template>
    <b-button-group>
        <slot name="prefix"></slot>

        <b-button
            :disabled="disableUp"
            @click="moveUp()"
            size="sm"
            v-if="!disableMove"
            variant="primary"
        >
            <chevron-up-icon />
        </b-button>

        <b-button
            :disabled="disableDown"
            @click="moveDown()"
            size="sm"
            v-if="!disableMove"
            variant="primary"
        >
            <chevron-down-icon />
        </b-button>

        <b-button
            @click="removeItem()"
            size="sm"
            v-if="!disableDelete"
            variant="danger"
        >
            <delete-forever-icon />
        </b-button>

        <slot></slot>
        <slot name="suffix"></slot>
    </b-button-group>
</template>

<script>
import _ from "lodash";
import ChevronUpIcon from "vue-material-design-icons/ChevronUp";
import ChevronDownIcon from "vue-material-design-icons/ChevronDown";
import DeleteForeverIcon from "vue-material-design-icons/DeleteForever";

export default {
    name: "OListActions",
    components: { DeleteForeverIcon, ChevronDownIcon, ChevronUpIcon },
    props: {
        list: { type: Array },
        index: { type: Number },
        disableMove: { type: Boolean, default: false },
        disableDelete: { type: Boolean, default: false },
        displayOrder: { type: String, default: null },
    },
    model: {
        prop: "list",
        event: "change",
    },
    methods: {
        onChanged() {
            if (this.displayOrder) {
                // Update the Display Order if specified
                var displayOrderField = this.displayOrder;

                _.each(this.list, function (item, index) {
                    item[displayOrderField] = index;
                });
            }

            this.$emit("change", this.list);
        },
        moveUp() {
            if (!this.disableMove) {
                this.list.splice(
                    this.index - 1,
                    0,
                    this.list.splice(this.index, 1)[0]
                );
                this.onChanged();
            }
        },
        moveDown() {
            if (!this.disableMove) {
                this.list.splice(
                    this.index + 1,
                    0,
                    this.list.splice(this.index, 1)[0]
                );
                this.onChanged();
            }
        },
        removeItem() {
            if (!this.disableDelete) {
                let removeIt = true;

                if ("active_end_date" in this.list[this.index]) {
                    var date = new Date();

                    // minimize race conditions
                    date.setSeconds(0, 0);
                    this.list[this.index].active_end_date = date.toJSON();

                    if (this.list[this.index].id) removeIt = false; // don't remove it as there is an ID
                    if (this.list[this.index].pk) removeIt = false; // don't remove it as there is an pk
                }

                if (removeIt) {
                    this.list.splice(this.index, 1);
                }

                this.onChanged();
            }
        },
    },
    computed: {
        disableUp() {
            return this.disableMove || this.index <= 0;
        },
        disableDown() {
            return this.disableMove || this.index >= this.list.length - 1;
        },
    },
};
</script>
